import SocialMediaSettingsStore from './SocialMediaSettingsStore'

export default SocialMediaSettingsStore
